import type { SetState } from '../store';

export type LoadingSliceProps = {
    loading: {
        isLoading: boolean;
        handleShowLoading: () => void;
        handleHideLoading: () => void;
    };
};

export const loadingSlice = ({ set, get }: SetState<LoadingSliceProps>): LoadingSliceProps => ({
    loading: {
        isLoading: false,
        handleShowLoading: () => {
            if (get().loading.isLoading) {
                return;
            }
            set(
                (state) => ({
                    loading: { ...state.loading, isLoading: true }
                }),
                undefined,
                'loading/showLoading'
            );
        },
        handleHideLoading: () => {
            set(
                (state) => ({
                    loading: { ...state.loading, isLoading: false }
                }),
                undefined,
                'loading/hideLoading'
            );
        }
    }
});
